import { ListItemButtonProps } from '@mui/material';
import { ListItemLink, ListItemLinkProps } from '@tsp-ui/core';
import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './IconMenuItem.module.scss';


export interface IconMenuItemProps extends ListItemButtonProps {
    title: string;
    to?: ListItemLinkProps['to'];
    selected?: boolean;
    disableExtraWidth?: boolean;
    icon?: ReactNode;
    state?: ListItemLinkProps['state'];
}

export function IconMenuItem({
    to, selected, disableExtraWidth, icon, title, state, ...otherProps
}: IconMenuItemProps) {
    return (
        <ListItemLink
            to={to ?? ''}
            state={state}
            selected={selected}
            className={styles.listItem}
            classes={{
                selected: clsx(styles.selected, {
                    [styles.extraWidth]: !disableExtraWidth
                })
            }}
            {...otherProps}
        >
            <span data-title={title}>
                {title}
            </span>

            {icon}
        </ListItemLink>
    );
}
